/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "../../common_components/Tables/EnhancedTable";
import Page from "../../common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";

const headCells = [
    { index: 1, id: "id", disablePadding: false, label: "Id" },
    { index: 2, id: "name", disablePadding: false, label: "Name" },
    { index: 3, id: "module.name", disablePadding: true, label: "Module" },
    { index: 4, id: "type.type", disablePadding: true, label: "Type" },
    { index: 5, id: "ownerUser.name", disablePadding: true, label: "Owner User" },
    { index: 6, id: "enabled", type: "bool", disablePadding: true, label: "Is Enabled" },
    { index: 7, id: "isStandard", type: "bool", disablePadding: true, label: "Is Standard" },
];

function List({ history }) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "id",
        orderDirection: "desc",
        pageNumber: 0,
        pageSize: 5,
    };

    const { Flows } = useContext(SettingsContext);

    function getFlows(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Flows.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getFlows();

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/settings/flows/${item.id}`);
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  name: filterValue,
                  module: {
                      name: filterValue,
                  },
                  type: {
                      type: filterValue,
                  },
                  ownerUser: {
                      name: filterValue,
                  },
              }
            : {};
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Flows">
                        <Button primary onClick={() => history.push("/settings/flows/add")}>
                            <Icon name="add" size="md" color="white" />
                            <span>Add</span>
                        </Button>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            defaultOrder={{ order: "desc", orderBy: "id" }}
                            keyColumnName="id"
                            onRowClick={onRowClickHandler}
                            onRequestData={getFlows}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
